module.exports = __webpack_public_path__ + "img/sdg-img@2x.b5d9bfb8.png";